module.exports = __webpack_public_path__ + "media/dashboard/sp_company_logos-7decf178.png";